import React, { useState } from 'react'; 
import ConfirmDialog from './ConfirmDialog';

export const QCDataDev = ({
  records,editMode,editableTitles,handleTitleChange,handleEditTitle,
  setEditMode,cycleMasterId,verifyTitle,verifyAllTitles,statusInfo,productsData
}) => { 
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState(() => () => {});

  
  const handleEditClick = (uniqueKey, title) => {
    /*setConfirmMessage('Are you sure you want to edit this title?');
    setConfirmAction(() => () => {
      setEditMode((prev) => ({ ...prev, [uniqueKey]: true }));
    });*/
    setEditMode((prev) => ({ ...prev, [uniqueKey]: true }));
    //setConfirmOpen(true);
  };
  
  const formatQcStatus = (status) => {
  if (!status || status === "none") return "Not verified";
   
  return status.charAt(0).toUpperCase() + status.slice(1);
};

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[1080px] ">
        {/* Table Header */}
        <div className='grid grid-cols-[13%_87%]'>
        <div className="flex justify-center w-40 h-40">
  <img
  src={productsData[records.productId].product_image_url || "/feedsumo-new/no_image.png"}
  alt={productsData[records.productId].product_name}
  className="mt-5 p-2 border-2 border-gray-300 rounded-md object-cover w-full"
/>
</div>

  
      <div className='pl-2'>
        <div className="flex items-center border-b border-gray-300 dark:border-gray-600 pb-2 text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase">
          <div className="w-40 text-left">Permutations</div>
          <div className="flex-1 w-full sm:w-1/2 pl-4">Titles</div>
           
           
          <div className="w-32 text-center">Options</div>
            
        </div>

        {/* Table Rows */}
        {Array.isArray(records?.title) &&
          records.title.map((item, idx) => {
            const uniqueKey = `${records.productId}_${idx}`;
            const isEditing = editMode[uniqueKey];
 

            return (
              <div
                key={uniqueKey}
                className={`flex flex-wrap items-start text-sm border-t border-gray-200 py-2 pl-2`}
              >
                {/* Permutation */}
                <div className="w-40 text-left font-medium text-gray-800 dark:text-gray-200">
                  {item.key === 'start'
                    ? 'Baseline title'
                    : item.key.charAt(0).toUpperCase() + item.key.slice(1)}
                </div>

                {/* Title Field */}
                <div className="flex-1 w-full sm:w-1/2">
                  {!isEditing ? (
                   <span className="flex items-center space-x-1 break-words pl-2 text-gray-800 dark:text-gray-200" title={item.qc_status}>
  <span>{item.title}</span>
   {item.key !== 'start' ? (
    <span
      className={`px-2 py-0.5 text-xs rounded-full text-white dark:bg-zinc-700 dark:text-zinc-300 ${
        item.qc_status === 'verified' ? 'bg-green-500' : 'bg-red-500'
      } whitespace-nowrap min-w-[80px] text-center`}
    >
      {formatQcStatus(item.qc_status)}
    </span>
  ) : null}
     
</span>

                  ) : (
                    <input
                      type="text"
                      value={editableTitles[uniqueKey] || item.title}
                      onChange={(e) => handleTitleChange(e, uniqueKey)}
                      className="border px-2 py-1 rounded w-full mt-1"
                    />
                  )}
                </div>
 
                  {/*  {item.key !== 'start'  ? 
                     
                    <div className="w-24 text-center pr-2 text-gray-800 dark:text-gray-200">
                    {(formatQcStatus(item.qc_status) === 'Not verified') ?
                       <span className='text-xs rounded-sm bg-red-500 text-white px-1 py-1'>{formatQcStatus(item.qc_status)}</span>
                    :  <span className='text-xs rounded-sm bg-green-500 text-white px-1 py-1'>{formatQcStatus(item.qc_status)}</span> 
                    } 
                    </div> : ''}*/}
                    {item.key !== 'start'  ? 
                    <div className="w-32 text-left mt-2 sm:mt-0 space-x-2 pl-2">
                      
                      {(!isEditing ? (
                          <div>
                          <button disabled={statusInfo.cycle_status === 'started'}
                            className={` hover:underline ${statusInfo.cycle_status === 'started' ? 'text-gray-300 cursor-not-allowed': 
                                      'text-blue-600 cursor-pointer'}`}
                            onClick={() => handleEditClick(uniqueKey, item.title)}
                             
                          >
                            Edit
                          </button>
                          {(formatQcStatus(item.qc_status) === 'Not verified') ?
                          <button
                              disabled={statusInfo.cycle_status === 'started'}
                              className={`pl-2 hover:underline ${statusInfo.cycle_status === 'started' ? 'text-gray-300 cursor-not-allowed': 
                                      'text-green-600 cursor-pointer'}`}
                              onClick={() =>
                                verifyTitle(
                                  cycleMasterId,             
                                  records.productId,         
                                  idx,
                                  uniqueKey,
                                  item.key,                  
                                  'verified',
                                                  
                                )
                              } 
                            >&nbsp;&nbsp;Verify</button>
                            : <button
                              disabled={statusInfo.cycle_status === 'started'}
                              className={`pl-2 hover:underline ${statusInfo.cycle_status === 'started' ? 'text-gray-300 cursor-not-allowed': 
                                      'text-green-600 cursor-pointer'}`}
                              onClick={() =>
                                verifyTitle(
                                  cycleMasterId,             
                                  records.productId,         
                                  idx,
                                  uniqueKey,
                                  item.key,                  
                                  'not verified'                
                                )
                              }
                               
                            >
                              Unverify
                            </button>
                            }
                          </div>
                        ) : (
                          <div className="flex gap-2 justify-center">
                            <button disabled={
                                  !editableTitles[uniqueKey] ||
                                  editableTitles[uniqueKey].trim() === item.title.trim()
                                }
                              onClick={() =>
                                handleEditTitle(
                                  cycleMasterId,            // test_cycle_id
                                  records.productId,        // product_id
                                  idx,                      // index
                                  uniqueKey,                // uniqueKey
                                  editableTitles[uniqueKey],// new title
                                  item.key,                 // key
                                  item.title                // old title
                                )
                              }
                              className={` 
    ${
      !editableTitles[uniqueKey] ||
      editableTitles[uniqueKey].trim() === item.title.trim()
        ? " cursor-not-allowed"
        : "text-green-600 cursor-pointer"
    }`}
                            >
                              Save
                            </button>
                            <button
                              onClick={() => {
                                setEditMode((prev) => ({ ...prev, [uniqueKey]: false }));
                              }}
                              className="text-red-500 hover:underline"
                            >
                              Cancel
                            </button>
                          </div>
                        ))}
                    </div>
                    : ''}
              </div>
            );
          })}
          
          <div className='text-right pr-5'>
            {records.qc_status === 'verified' ? 
              <button disabled={statusInfo.cycle_status === 'started'}
                className={`px-3 py-1 text-sm rounded-md text-white ${statusInfo.cycle_status === 'started' ? 'bg-gray-300 cursor-not-allowed': 
                  'bg-red-500 cursor-pointer'}`}
                onClick={() => verifyAllTitles(cycleMasterId, records.productId, 'not verified')}> Unverify All</button> : 
              <button disabled={statusInfo.cycle_status === 'started'} 
                  className={`px-3 py-1 text-sm rounded-md text-white ${statusInfo.cycle_status === 'started' ? 'bg-gray-300 cursor-not-allowed': 
                  'bg-green-500 cursor-pointer'}`}
                   onClick={() => verifyAllTitles(cycleMasterId,records.productId,'verified')}>Verify All</button>
            }
          </div>
          </div>
          </div>
      </div>{/* min-w-[1080px] */}

      {/* Confirm Dialog */}
      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={() => {
          confirmAction();
          setConfirmOpen(false);
        }}
        message={confirmMessage}
      />
    </div>
  );
};
